import queryString from 'querystring';
import * as Cookie from 'tiny-cookie'
import {
  isIphone,
  isIpad,
  isWeiXin,
  isApp,
  isAndroid,
  isOTT,
  getInvoker,
  getPlatform,
  orderInvoker,
  isZfb,
  isUCBrowser,
  isSupportsWebP,
  isIphoneApp,
  isIpadApp
} from './env';
// eslint-disable-next-line camelcase
import get_param from '../param'
import config from '../../constant/config'
import { ANALYSIS_ID, TEST_PASSWORD } from '../../constant/CookieKeys'
import { uuid } from '../../tools/uuid'
import { get_ticket } from './ticket'
import { setShare } from './share'
import { ACTION_GET_USER_INFO, ACTION_GET_ACT_INFO } from '../../constant/eventbus'
import { isFunction } from '../typeof'
import { get_appversion_from_ua, compare_version } from './version'
import { error_event } from './analysis';
import { isSupportWebPSchema } from '../towebp';

window.params = queryString.parse(window.location.search.substr(1)) // 去掉search前面的？ ，解析所有参数

export const DEFAUL_APP_VERSION = get_appversion_from_ua(); //'6.9.9_vipact';

function isFullScreen() {
  try {
    if (get_param('isFullScreen') !== '1') {
      return false
    }
    if (!gact.is_app) {
      return false;
    }
    return (gact.is_iphone && compare_version('>=', '6.5.6')) || (gact.is_android && compare_version('>=', '6.5.12')) //高版本频道才支持全屏
  } catch (e) {
    error_event(e, { 'tips:': 'isFullScreen' });
    return false;
  }
}



export function init_gact() {
  console.log('init_gact')
  window.gact = {
    is_app: isApp(),
    is_h5: !isApp(),
    is_wx: isWeiXin(),
    is_zfb: isZfb(),
    is_iphone: isIphone(),
    is_ipad: isIpad(),
    is_android: isAndroid(),
    is_uc: isUCBrowser(),
    is_ott: isOTT(),
    is_mpp: !isOTT(),
    is_ios_app: isApp() && !isAndroid(),
    is_iphone_app: isIphoneApp(),
    is_ipad_app: isIpadApp(),
    os: isAndroid() ? 'android' : 'ios',
    invoker: getInvoker(),//前端判断环境用的，和支付无关，支付是写死的
    order_invoker: orderInvoker(), //下单用的invoker
    fe_platform: getPlatform(), //废弃
    source: get_param('source') || window.rootdata.act_name,
    test_env: get_param('test_env') === "1" ? 1 : 0, //是否是内测环境
    debug: get_param('debug') === "1" ? 1 : 0, //是否模拟app环境
    edit: get_param('edit') === "1" ? 1 : 0, //是否是edit模式，显示边框_dx_cap
    edit_color: get_param('edit_color') || '#1890ff',
    auto_login: get_param("auto_login") === "1",
    f_release: get_param('f_release') || '1', //1 线上  0 预览
    preview_module: get_param('m_name') || '', //预览模块，预览模式下模块具有高亮边框
    disable_download: get_param('disable_download'), //禁用下载
    disable_wxpay: isZfb() || isUCBrowser(), //禁用微信支付的环境
    isSupportsWebP: isSupportsWebP(),
    is_test: false, //是否是测试配置
    _dx_cap: window.params._dx_cap || '1', //顶象验证码ID 1是滑动2是点选
    show_user_info: window.params.show_user_info === '1' || params.debug === '1',
    hide_head_mask: get_param('hide_head_mask') === '1', //隐藏头部阴影
    params: window.params,
    open_type: get_param('open_type'), // smkj 代表开启分层检测，识别到神秘空间人群自动打开神秘空间
    user_group_ids: get_param('user_group_ids'), // 用户分群id，多个人群ID用户逗号分开
  } //全局变量

  if (!window.params.show_user_info && !gact.is_app) {
    gact.show_user_info = true;
  }

  //http://jira.imgo.tv/browse/APHONEAPP-17712
  if (!window.params._dx_cap) {
    //SDK上线后改为低于某版本才自动改为2
    if (gact.is_app && gact.is_android) {
      gact._dx_cap = '2';
    }
  }

  gact.is_full_screen = isFullScreen();

  let analysis_id = Cookie.get(ANALYSIS_ID);
  if (!analysis_id) {
    analysis_id = "act" + uuid();
    Cookie.set(ANALYSIS_ID, analysis_id);
    gact.analysis_id = analysis_id;
  } else {
    gact.analysis_id = analysis_id;
  }

  if (gact.test_env) {
    gact.config = config['test_env']
  } else {
    gact.config = config['online_env']
  }
  if (gact.is_app) {
    get_device_info(function () {
      window.$bus.$emit(ACTION_GET_ACT_INFO); //获取活动信息
      get_ticket(ticket => {
        window.$bus.$emit(ACTION_GET_USER_INFO, ticket);
        if (gact.is_android) {
          //屏蔽频道页自带的滑动手势
          MgtvApi.callhandler('requestTouchEvent', {
            touchEvent: 1
          });
        }
      })
    });
  } else {
    window.$bus.device_info.did = gact.analysis_id;
    window.$bus.device_info.mac = gact.analysis_id;
    if (window.__ac) {
      window.__ac.did = gact.analysis_id
    }
    window.$bus.$emit(ACTION_GET_ACT_INFO); //获取活动信息
    get_ticket((ticket) => {
      window.$bus.$emit(ACTION_GET_USER_INFO, ticket);
    });
  }

  gact.is_test = gact.f_release !== '1';
  if (gact.is_test && (!Cookie.get(TEST_PASSWORD))) {
    window.$bus.is_need_test_password = true
  }
}

export function get_device_info(cb) {
  if (window.gact.is_app) {
    if (gact.debug) {
      window.$bus.device_info = {
        appVersion: DEFAUL_APP_VERSION,
        mac: '0000-0000-0000',
        did: '0000-0000-0000',
        osType: window.gact.os,
        osVersion: '13.2.2'
      };
      if (cb) {
        cb();
      }
    } else {

      //统计SDK是否可以正常执行
      const startTime = new Date().getTime()
      setTimeout(() => {
        reportDeviceInfoTimeout()
      }, 3000)

      reportDeviceInfoCall()

      MgtvApi.getDeviceInfo(function (_device_info) {
        reportDeviceInfoGet(_device_info, startTime)

        if (_device_info.length !== 0) {
          const device_info = JSON.parse(_device_info);
          //防止老版本中mac和did为空，导致下单失败
          if (!device_info.mac) {
            device_info.mac = '0000-0000-0000';
          }
          if (!device_info.did) {
            device_info.did = '0000-0000-0000';
          }
          window.$bus.device_info = device_info;

          //为apm设置deviceInfo
          try{
            if(window.apmInst && window.apmInst.setDeviceInfo){
              window.apmInst.setDeviceInfo(device_info)
            }
          }catch(e){

          }

        } else {
          window.$bus.device_info = {
            appVersion: DEFAUL_APP_VERSION,
            mac: '0000-0000-0000',
            did: '0000-0000-0000',
            osType: window.gact.os,
            osVersion: '13.2.2'
          };
        }
        if (cb) {
          cb();
        }



      });
    }
  }
}

function reportDeviceInfoCall() {
  try {
    if (window.apmInst) {
      window.apmInst.event('getDeviceInfo', {
        event: 'call'
      })
    }
  } catch (e) {

  }
}


function reportDeviceInfoGet(info, startTime) {
  try {
    const useTime = new Date().getTime() - startTime
    const isError = (!info || info.length < 20) ? 1 : 0
    if (window.apmInst) {
      if (isError) {
        window.apmInst.event('getDeviceInfo', {
          event: 'empty',
          info: info,
          useTime
        })
      } else {
        window.apmInst.event('getDeviceInfo', {
          event: 'success',
          useTime
        })
      }
    }
  } catch (e) {

  }
}

function reportDeviceInfoTimeout() {
  try {
    if (window.apmInst) {
      if(window.$bus.device_info.notInit){
        window.apmInst.event('getDeviceInfo', {
          event: 'timeout',
        })
      }
    }
  } catch (e) {

  }
}
